import { makeStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import React from 'react';

import { toCssValue } from '../../core/utils/theme.utils';
import NoDataContainer from '../NoDataContainer';
import TableGrid, { MainColumns } from '../TableGrid';

interface OwnProps {
  columns: MainColumns[];
  rows?: any[];
  translationsScope: string;
}

const defaultColumnProp = {
  resizable: false,
  flex: 1,
  menuTabs: [],
  autoHeight: true,
  wrapText: true,
  sortable: false,
};

const HistoricalTable: React.FC<OwnProps> = ({ columns, rows, translationsScope }) => {
  const classes = useStyles();
  return (
    <TableContainer component={Paper} className={classes.historyTable}>
      {rows && rows?.length ? (
        <TableGrid
          columns={columns}
          rowSelection={false}
          isShowSideBar={false}
          translationKey={translationsScope}
          originalProps={{
            rowData: rows,
            rowModelType: 'clientSide',
            domLayout: 'autoHeight',
            defaultColDef: defaultColumnProp,
          }}
        />
      ) : (
        <NoDataContainer />
      )}
    </TableContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  historyTable: {
    '& .ag-cell': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1,
      padding: toCssValue([theme.spacing(3), theme.spacing(6)]),
    },
  },
}));

export default HistoricalTable;
